module.exports = __webpack_public_path__ + "img/cases-brand-maxam-lazyload-21.ee561897.jpg";